import { render, staticRenderFns } from "./vsSelectGroup.vue?vue&type=template&id=0c34edd0"
import script from "./vsSelectGroup.vue?vue&type=script&lang=js"
export * from "./vsSelectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports